import { render, staticRenderFns } from "./SpellCheckBox.vue?vue&type=template&id=84302f7e&scoped=true&"
import script from "./SpellCheckBox.vue?vue&type=script&lang=js&"
export * from "./SpellCheckBox.vue?vue&type=script&lang=js&"
import style0 from "./SpellCheckBox.vue?vue&type=style&index=0&id=84302f7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84302f7e",
  null
  
)

export default component.exports